import { useEffect, useRef, useState } from "react";
import IndoorPositioningTripwire from "../../../../api/IndoorPositioningTripwire";

// Loads the site's tripwire lines for the live dashboard overlay (and, since
// HistoryWorkspaceModal/PublicLiveDashboard reuse LiveCanvas, for replay and
// the public view too). Unlike personnel/equipment (2s polls -- they move),
// tripwires are near-static configuration that only an operator editing the
// floor plan changes, so this refreshes every 60s: fast enough to pick up an
// edit within a dashboard session, without adding meaningful request volume.
const REFRESH_MS = 60000;

export const useLiveTripwires = (machineID, open = true) => {
  const [tripwires, setTripwires] = useState([]);
  const [tripwiresLoading, setTripwiresLoading] = useState(false);

  const isActiveRef = useRef(true);

  useEffect(() => {
    if (!open || !machineID) return;

    isActiveRef.current = true;
    setTripwires([]);

    const fetchTripwires = async () => {
      if (!isActiveRef.current) return;
      try {
        const response = await IndoorPositioningTripwire.List(machineID);
        if (response.code === 200 && isActiveRef.current) {
          setTripwires(response.data?.tripwires || []);
        }
      } catch (error) {
        console.error("Failed to fetch tripwires:", error);
      } finally {
        if (isActiveRef.current) setTripwiresLoading(false);
      }
    };

    setTripwiresLoading(true);
    fetchTripwires();

    const interval = setInterval(fetchTripwires, REFRESH_MS);

    return () => {
      isActiveRef.current = false;
      clearInterval(interval);
    };
  }, [open, machineID]);

  return { tripwires, tripwiresLoading };
};
